import Decimal from "decimal.js";
import { ObjectPlugin } from "vue";

const decimalPlugin = () => {
  return {
    parseDecimal(value: string): Decimal | null {
      if (value === "" || value === null) {
        return null;
      } else {
        try {
          return new Decimal(value.replaceAll(/[^\d.-]/g, ""))
            .mul(new Decimal(100))
            .round()
            .div(new Decimal(100));
        } catch (e) {
          console.log(e);
          return null;
        }
      }
    },
    asDecimal(value: string | Decimal | number) {
      return new Decimal(value);
    },
    isDecimal(value: any) {
      return value instanceof Decimal;
    },
    DecimalClass: Decimal,
  } as const;
};

export type DecimalPlugin = ReturnType<typeof decimalPlugin>;

export const $decimal: ObjectPlugin = {
  install: (app, _) => {
    app.config.globalProperties.$decimal = decimalPlugin();
  },
};

export default $decimal;
